// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_os-8";
export var editMode = "_os-3";
export var headerRow = "_os-a";
export var headerTitle = "_os-b";
export var product = "_os-1";
export var productDetails = "_os-5";
export var productDivider = "_os-7";
export var productImage = "_os-2";
export var productInfo = "_os-4";
export var productTitle = "_os-6";
export var strikethrough = "_os-9";
export var upsellProductsCard = "_os-0";